import { assert } from '@sama/js-core';
// eslint-disable-next-line import-whitelist -- team split hack until cacheImageSourcePixels is moved to 2D folder
import { AbstractSensorContentStore2D } from '../../2d/shared/state/abstract-sensor-content-store-2d';
import { AnnotationState } from '../../outputs/annotation/annotation-shared/state/root/annotation-state';
import { LoadImageService } from '../../shared/misc-services/load-image.service';
import { extractImageData } from '../../shared/misc-utilities/image-utils';
import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { ImageFromDataState, toImageData } from './image-from-data-state';

export type SensorFrame2D = {
  imageUrl: string;
  altImageUrl?: string;
  crossOrigin?: string | null;
};

export class SensorRendererState<SensorFrame> extends ImageFromDataState {
  constructor(
    public sensorFrames: Array<SensorFrame | undefined>,
    height: number,
    width: number,
    public clampOffset: Point2D = [0, 0],
  ) {
    super(width, height);
  }
}

export function cacheImageSourcePixels(
  loadImageService: LoadImageService,
  store: AbstractSensorContentStore2D,
) {
  return new Promise<ImageData>((resolve) => {
    const { frameNumber, sensorRendererState } = store.state();
    if (sensorRendererState.data) {
      resolve(toImageData(sensorRendererState));
    } else {
      const sensorFrame = sensorRendererState.sensorFrames[frameNumber];
      assert(sensorFrame, 'The frame must already be loaded');
      void loadImageService.loadImage(sensorFrame.imageUrl).then((img) => {
        const result = extractImageData(img);
        store('sensorRendererState')('data').set(result.data);
        resolve(result);
      });
    }
  });
}

export function getFrameNumberForEventTracking(state: AnnotationState) {
  return state.status === 'ready' ? state.frameNumber : undefined;
}
